module.exports = __webpack_public_path__ + "static/img/platphom_logo.7a2eb67e.png";